<adapt-feature-guidance [configItem]="configItem">
    <p>Enabling the meeting feature allows you to use the meeting framework within a team.</p>
</adapt-feature-guidance>

<adapt-feature-configuration [configItem]="configItem">
    <adapt-configure-meeting-agenda-templates></adapt-configure-meeting-agenda-templates>
</adapt-feature-configuration>
